'use strict';

const clicklock = require('app_common/components/clicklock');
const updateDom = require('app_common/components/updateDom');
const {getCsrfObject} = require('app_common/components/security');
const {encodeHtml} = require('sswd_base/util/XStringUtils');

/**
 * カート追加のURLを取得
 *
 * @returns {string} カートURL
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * カート追加用のメッセージを含むタグのjQueryオブジェクトを取得する。
 * `app_custom/cartridge/templates/default/components/addition/addToMessagesAlert.isml`内のカート用のタグに対応する。
 *
 * @returns {JQuery<Element>} カート追加用のメッセージを含むタグのjQueryオブジェクト
 */
function getAddrToCartMessages() {
    const $addrToCartMessages = $('.add-to-cart-messages-sample');
    return $addrToCartMessages;
}

/**
 * カート追加時のポップアップを表示する。
 *
 * @param {object} data ミニカートに渡すデータ
 * - quantityTotal: ＜ミニカートで表示するカート内の商品数量＞ 例: `2`
 * - minicartCountOfItems: ＜ミニカートのaタグのtitle属性にセットするメッセージ＞ 例: `'Cart 2 Items'`
 */
function clickAddToMessageAlert(data) {
    $('.minicart').trigger('count:update', data);

    // メッセージエリアを取得する
    const $addrToCartMessages = getAddrToCartMessages();
    const message = $('.add-to-basket-alert-sample', $addrToCartMessages).html();

    // 表示用に組み立てる
    const $body = $('body');
    const $messages = $('<div class="add-to-cart-messages"></div>');
    const $alert = $(
        `<div class="alert alert-success add-to-basket-alert text-center" role="alert">${message}</div>`
    );
    $messages.append($alert);
    $body.append($messages);
    setTimeout(function () {
        $alert.remove();
        $messages.remove();
    }, 5e3);
}

/**
 * カート追加失敗時のポップアップを表示する。
 *
 * @param {string[]} error - エラーメッセージの配列。例: `['エラーが発生しました。']`
 * @returns {void}
 */
function clickAddFalseToMessageAlert(error) {
    // メッセージエリアを取得する
    const $addrToCartMessages = getAddrToCartMessages();
    const messageHtmlStr = $('.add-to-basket-alert-false', $addrToCartMessages).html();

    // 文字列をjQueryオブジェクトに変換
    const $messageHtml = $(messageHtmlStr);
    // メッセージを作成する
    let message;
    if (Array.isArray(error) && error.length > 0) {
        if (error.length === 1) {
            message = `${encodeHtml(error[0])}`;
        } else {
            message = '<ul>';
            error.forEach((e) => {
                message += `<li>${encodeHtml(e)}</li>`;
            });
            message += '</ul>';
        }
    } else {
        message = $addrToCartMessages.data('message-systemerror');
    }
    // メッセージ部分を上書きする
    $messageHtml.find('.pull-right.ml-2').html(message);

    // 表示用に組み立てる
    const $body = $('body');
    const $messages = $('<div class="add-to-cart-messages"></div>');
    const $alert = $(
        `<div class="alert alert-success add-to-basket-alert text-center" role="alert">${$messageHtml.prop(
            'outerHTML'
        )}</div>`
    );
    $messages.append($alert);
    $body.append($messages);
    setTimeout(function () {
        $alert.remove();
        $messages.remove();
    }, 5e3);
}

/**
 * スクロールアニメーションが完了するまで待つ関数
 *
 * @returns {Promise<void>} スクロールアニメーションが完了すると解決されるPromise。
 */
function waitForScroll() {
    return new Promise((resolve) => {
        require('base/components/scrollAnimate')();

        // animate関数が完了した後にPromiseを解決する
        $('html, body').promise().done(resolve);
    });
}

/**
 * 対象画面を再描画する
 * 在庫がない、販売期間外の場合は部分更新とし、
 * オフラインの場合は、ページが見つからないため全体を再描画する
 *
 * @param {string} url - 再描画対象
 * @param {string} refreshArea - 更新部分を指定するクラス名
 */
function refreshProductView(url, refreshArea) {
    $.ajax({
        url: url,
        method: 'GET',
        success: function (response) {
            // 在庫がない、販売期間外の場合は部分更新
            updateDom(response, refreshArea);
        },
        error: function () {
            // TODO：商品詳細オフライン状態の時の画面遷移
            // リダイレクトさせ404エラー画面を表示
            window.location.href = url;
        },
    });
}

/**
 * (本関数は、SFRAの「product/base.js#miniCartReportingUrl」を移植したもの)
 *
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string} url - a string representing the end point to hit so that the event can be recorded
 */
function miniCartReportingUrl(url) {
    if (!url) {
        return;
    }
    $.ajax({
        url,
        method: 'GET',
        success: function () {
            // reporting urls hit on the server
        },
        error: function () {
            // no reporting urls hit on the server
        },
    });
}

/**
 * カートに追加
 * @param {object} e イベント
 * @return {Promise<any>} postForm返却値
 */
async function doAddToCart(e) {
    if (!e) {
        return;
    }

    // 商品IDと数量取得
    const $addCartButton = $(e.currentTarget);
    const productId = $addCartButton.data('pid');
    // 商品詳細画面にて入力された数量を取得する
    // PC版とモバイル版でそれぞれ取得する
    const quantityElementDesktop = $addCartButton
        .closest('.row')
        .prev()
        .find('.form-control[name="quantity"]');
    const quantityElementMobile = $addCartButton
        .closest('.row')
        .find('.form-control[name="quantity"]');

    let quantity;

    if (quantityElementDesktop.length) {
        quantity = quantityElementDesktop.val();
    } else if (quantityElementMobile.length) {
        quantity = quantityElementMobile.val();
    }

    // お気に入り画面など数量設定がない場合はデフォルトで1を設定する
    quantity = quantity || 1;

    // 取得した商品IDと数量をポストデータオブジェクトに変換
    let postDataObj = {
        productId: productId ? productId + '' : '',
        quantity: parseInt(quantity, 10),
    };

    // コントローラー呼び出し用URL取得
    const addToCartUrl = getAddToCartUrl();

    const csrfObject = getCsrfObject();
    const csrfTokenName = csrfObject.tokenName;
    const csrfTokenValue = csrfObject.token;

    // フォームデータ作成
    const formData = new FormData();
    formData.append('pid', postDataObj.productId);
    formData.append('quantity', postDataObj.quantity);
    formData.append(csrfTokenName, csrfTokenValue);

    const postForm = require('sswd_base/components/XPostForm');
    const result = await postForm(addToCartUrl, formData);
    return result;
}

/**
 * カートに追加
 * 追加後のメッセージ表示を変更するために移植
 * セット品やバンドル品に関する処理も削除
 */
function addToCart() {
    $('body').on('click', 'button.add-to-cart, button.add-to-cart-global', async (e) => {
        // クリックイベントをロックする
        if (!clicklock.lock()) {
            // ロックできなかった場合は何もしない
            return;
        }
        try {
            // スピナーを開始する
            $('body').trigger('product:beforeAddToCart', this);

            // カート追加処理
            const result = await doAddToCart(e);

            // メッセージ表示
            if (result.success) {
                const data = result.data;
                // カート追加成功時は、デザインされたポップアップを表示する
                clickAddToMessageAlert(data);
                $('body').trigger('product:afterAddToCart', data);
                const reportingURL = data.reportingURL;
                miniCartReportingUrl(reportingURL);
            } else {
                // 画面上部へスクロール
                await waitForScroll();
                // エラーメッセージの表示
                let error;
                if (result.error) {
                    error = result.error;
                } else if (result.csrfError) {
                    const $addrToCartMessages = getAddrToCartMessages();
                    error = [$addrToCartMessages.data('message-csrferror')];
                } else {
                    const $addrToCartMessages = getAddrToCartMessages();
                    error = [$addrToCartMessages.data('message-systemerror')];
                }
                clickAddFalseToMessageAlert(error);
                // リフレッシュURL、カスタムイベント取得
                const $addCartButton = $(e.currentTarget);
                const refreshUrl = $addCartButton.data('refresh-url');
                const refreshArea = $addCartButton.data('refresh-area');

                // イベントをトリガーし呼び出し元に応じた処理を行う
                refreshProductView(refreshUrl, refreshArea);
            }
        } catch (err) {
            // 画面上部へスクロール
            await waitForScroll();
            // エラーメッセージの表示
            const $addrToCartMessages = getAddrToCartMessages();
            const error = [$addrToCartMessages.data('message-systemerror')];
            clickAddFalseToMessageAlert(error);
        } finally {
            // スピナーを停止する
            $.spinner().stop();
            // クリックイベントをアンロックする
            clicklock.unlock();
        }
    });
}

/**
 * 商品詳細およびお気に入りリスト画面の「すぐ購入」ボタンのクリック時の処理を設定する。
 *
 * @returns {void}
 */
function handleBuyNow() {
    // 「商品追加あり」の「すぐ購入」ボタンがクリックされた際の処理
    $('.co-buy-now').on('click', async (event) => {
        event.preventDefault();
        if (!clicklock.lock()) {
            return;
        }
        try {
            // 商品IDと数量取得
            const $addCartButton = $(event.currentTarget);
            const productId = $addCartButton.data('pid');
            // 商品詳細画面にて入力された数量を取得する
            // PC版とモバイル版でそれぞれ取得する
            const quantityElementDesktop = $addCartButton
                .closest('.row')
                .prev()
                .find('.form-control[name="quantity"]');
            const quantityElementMobile = $addCartButton
                .closest('.row')
                .find('.form-control[name="quantity"]');

            let quantity;

            if (quantityElementDesktop.length) {
                quantity = quantityElementDesktop.val();
            } else if (quantityElementMobile.length) {
                quantity = quantityElementMobile.val();
            }

            // お気に入り画面など数量設定がない場合はデフォルトで1を設定する
            quantity = quantity || 1;

            // 「すぐ購入」を実行する
            const {getBuyNowObj} = require('../components/buyNow');
            const {execBuyNow} = require('../co/coBuyNow');
            const buyNowObj = getBuyNowObj(productId, quantity);
            await execBuyNow(buyNowObj);
        } finally {
            clicklock.unlock();
        }
    });
}

module.exports = {
    addToCart,
    doAddToCart,
    handleBuyNow,
};
